import {useAppSelector} from "../../../redux/hooks";
import {dashboardStore} from "../store/dashboardPageStore";
import {useCallback} from "react";
import {DashboardTimeRangeOptionType} from "../store/IDashboardPageStore";

export interface INotesPlayedDurationSwitcherLogic {
  changeSelectedRange: (selectRange: DashboardTimeRangeOptionType) => void;
  selectedRange: DashboardTimeRangeOptionType;
}

export const useNotesPlayedDurationSwitcherLogic = (): INotesPlayedDurationSwitcherLogic => {
  const selectedRange = useAppSelector(dashboardStore.getNotesPlayedSelectedRange);
  const changeSelectedRange = useCallback((selectRange: DashboardTimeRangeOptionType) => {
    dashboardStore.setNotesPlayedRange(selectRange);
  }, []);
  return {
    selectedRange,
    changeSelectedRange,
  };
}
